module.exports = __webpack_public_path__ + "img/online-user-guide.7a569a02.png";